/* eslint-disable no-param-reassign */
import { thunk, action, computed } from 'easy-peasy'

export default {
  step: 0,
  nextStep: thunk(async (actions, payload, { getState }) => {
    const { step } = getState()
    actions.setStep(step + 1)
  }),
  prevStep: thunk(async (actions, payload, { getState }) => {
    const { step } = getState()
    actions.setStep(step - 1)
  }),
  setStep: action((state, payload) => {
    state.step = payload
  }),
  current: computed(state => state.pages[state.step]),
}
